export default __webpack_public_path__ + "static/FestlTour-Teaser-eac7564b3cc23c978f9401592eeb879c.jpg";